export const ADD_MENU ="ADD_MENU"
export const ADD_SELECTLIST ="ADD_SELECTLIST"
export const FLAVORSINDEX ="FLAVORSINDEX"
export const MODIFIERGROUPINDEX ="MODIFIERGROUPINDEX"
export const EDIT_STEPPRODUCT ="EDIT_STEPPRODUCT"
export const EDIT_MODIFIERGROUP ="EDIT_MODIFIERGROUP"
export const CLEAR_PRODUCTOBJ ="CLEAR_PRODUCTOBJ"
export const ADD_PRODUCTOBJ ="ADD_PRODUCTOBJ"
export const PRODUCTINDEX ="PRODUCTINDEX"
export const CLEAR_SELECT ="CLEAR_SELECT"
export const ADD_MODIFIERGROUP ="ADD_MODIFIERGROUP"
export const INIT_CHOOSEMODIFIERARR ="INIT_CHOOSEMODIFIERARR"
export const EDIT_CHOOSEMODIFIERARR ="EDIT_CHOOSEMODIFIERARR"
export const CLEAR_MODIFIERGROUP ="CLEAR_MODIFIERGROUP"
